import { render } from "./ScrollBox.vue?vue&type=template&id=cf54a08c&scoped=true&ts=true"
import script from "./ScrollBox.vue?vue&type=script&lang=ts"
export * from "./ScrollBox.vue?vue&type=script&lang=ts"

import "./ScrollBox.vue?vue&type=style&index=0&id=cf54a08c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/attack-flow/attack-flow/src/attack_flow_builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf54a08c"]])

export default __exports__